

const v1 = resolve => require(['./desktop/v1.vue'], resolve);
const v1_mobile = resolve => require(['./mobile/v1_mobile.vue'], resolve);

export default {
  v1,
  v1_mobile
}
